var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionsLeaves(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 719,
    viewBox: "0 0 576 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565.45 707.384c-72.459-75.347-129.112-170.492-129.388-283.14-.326-71.886 20.669-142.145 60.331-201.892-59.742 39.674-130.004 60.67-201.893 60.33-107.47-.262-201.351-51.102-273.194-119.297-3.303-3.303-6.732-6.48-10.017-9.765L0 142.332l32.372-32.372a354.268 354.268 0 0113.09-12.474C111.053 37.958 199.29.102 293.746.349c100.066.261 221.497 71.356 287.63 136.694l.254.254c65.465 66.26 136.433 187.528 136.694 287.667.271 96.609-39.39 186.724-101.198 252.67l-40.713 40.712-10.962-10.962zM289.264 31.508c.182.182 0 0 0 0z",
    fill: "#F8F5FF"
  })));
}
export default SvgQuestionsLeaves;